import { awardsDataService } from "./services";
import { LibCard, ItemPage } from "./components";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import { IModuleConfig } from "../../interfaces";
import { ModuleTypeEnum } from "../../enums";
import {
  AddButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton
} from "./components/toolbar-items";
import {UserPermissions} from "../../definitions"

const config: IModuleConfig = {
  id: "awards",
  name: "Awards",
  view_permission: UserPermissions.viewAwards,
  edit_permission: UserPermissions.editAwards,
  icon: faAward,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: LibCard,
    itemPage: ItemPage
  },
  services: {
    getByPage: awardsDataService.getByPage,
    getSingle: awardsDataService.getSingle,
    create: awardsDataService.create,
    update: awardsDataService.update
  },
  utilities: {
    extractKey: (d: any) => {
      return d._id;
    },
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => {
      return d.main_program;
    }
  },
  toolbarItems: {
    library: [AddButton],
    create: [CancelButton, SaveButton],
    edit: [CancelButton, SaveButton],
    view: [AddButton, EditButton, DeleteButton]
  }
};

export default config;
